import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import Barcode from "react-barcode";
import products from "../../../../Data/products.json";
import { useParams } from "react-router-dom";
import { PrinterOutlined } from "@ant-design/icons";
import Loadercomponent from "../../../../Componets/Loader";
import { get_inventory } from "../../../../Controllers/Inventory/Batch";
import toast from "react-hot-toast";
import { Button } from "antd";

const InventoryView = () => {
  const { id } = useParams();

  const barcodeRef = useRef();

  const handleBarcode = useReactToPrint({
    content: () => barcodeRef.current,
  });

  const [loader, setLoader] = useState(false);
  const [values, setValues] = useState([]);
  const [salePrice, setSalePrice] = useState(0);

  const handleData = async (inventory) => {
    setLoader(false);
    setValues(inventory);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const inventory = await get_inventory(data);
      if (inventory?.status) {
        handleData(inventory?.data);

        let price = parseFloat(inventory?.data?.sale_price || 0);
        let tax = parseFloat(inventory?.data?.tax || 0);

        let tax_amount = (parseFloat(price || 0) * parseFloat(tax || 0)) / 100;
        let sale_price = parseFloat(price || 0) + parseFloat(tax_amount || 0);

        setSalePrice(sale_price);
      } else {
        toast?.error(inventory?.message);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <Loadercomponent loader={loader}>
        {values?.barcode ? (
          <div className="text-regular">
            <div className="flex p-4">
              <Button
                className="bg-white border rounded hover:border-green-500"
                type="button"
                size="large"
                onClick={handleBarcode}
              >
                Print Barcode <PrinterOutlined />
              </Button>
            </div>
            <div
              ref={barcodeRef}
              style={{
                width: "192px",
                height: "96px",
                padding: "4px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "10px",
              }}
            >
              <div
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  fontSize: "8px",
                }}
              >
                {values?.product?.name}
              </div>

              <div style={{ margin: "2px 0" }}>
                <Barcode
                  value={String(values?.barcode)}
                  width={1}
                  height={20}
                  fontSize={8}
                  displayValue={true}
                />
              </div>

              <div
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
              >
                OMR&nbsp;
                {parseFloat?.(salePrice || 0)?.toFixed(3)}
              </div>
            </div>
          </div>
        ) : (
          <div className="p-4 text-red-500">Barcode not available</div>
        )}
      </Loadercomponent>
    </div>
  );
};

export default InventoryView;
